const to_array = require('./to_array')
const template = require('lodash/template')
const dialog = template(require('../templates/alterar-data-pagamento.html'))
const GlobalAlerts = require('./GlobalAlerts');
const moment = require('moment');
const Lang = require('lang');

function AlterarDataPagamento() {
  nifty.body.overlay({
    fixed: true
  })
  const reportRows = to_array(document.querySelectorAll('[data-report]'))
  reportRows.forEach(addEventListener)
}

function addEventListener(reportRow) {
  reportRow.addEventListener('click', clickHandler)
}

function clickHandler(event) {
  nifty.body.overlay('show')
  event.preventDefault()
  event.stopPropagation()

  const reportId = event.currentTarget.dataset.report

  getReport(reportId)
    .done((response) => showModal(response))
    .fail(() => {
      GlobalAlerts.createAndShow({
        title: Lang.get('js/src/functions/AlterarDataPagamento.ops'),
        message: Lang.get('js/src/functions/AlterarDataPagamento.error_while_accessing_report'),
        type: 'warning'
      })
    })
    .always(() => nifty.body.overlay('hide'));
}

function showModal(report) {
  const modal = bootbox.dialog({
    title: report.descricao,
    message: dialog({
      dataPagamento: formatDate(report.dataPagamento)
    }),
    buttons: {
      cancel: {
        label: Lang.get('js/src/functions/AlterarDataPagamento.cancel'),
        className: 'btn-danger'
      },
      confirm: {
        label: Lang.get('js/src/functions/AlterarDataPagamento.change_date'),
        className: 'btn-success',
        callback: function () {
          nifty.body.overlay('show');
          const dataPagamento = $(this).find('#dataPagamento').val();
          updateReport(report.id, dataPagamento)
            .done(function (data) {
              GlobalAlerts.create({
                title: Lang.get('js/src/functions/AlterarDataPagamento.success'),
                message: Lang.get('js/src/functions/AlterarDataPagamento.payment_date_changed', { description: report.descricao, payment_date: dataPagamento }),
              });
            })
            .fail(function () {
              GlobalAlerts.create({
                type: 'danger',
                title: Lang.get('js/src/functions/AlterarDataPagamento.ops'),
                message: Lang.get('js/src/functions/AlterarDataPagamento.not_possible_to_validate_date'),
              });
            })
            .always(function () {
              $('#default-filter-data').trigger('click');
              nifty.body.overlay('hide');
            })
        }
      }
    }
  })

  modal.on('shown.bs.modal', function () {
    const input = $(this).find('#dataPagamento')
    input.datepicker()
  })

  return modal
}

function getReport(id) {
  return $.get(route('app.relatorios.show-json', {
    id: id
  }))
}

function updateReport(id, dataPagamento) {
  return $.ajax({
    method: 'PUT',
    url: route('app.relatorios.data-pagamento', {
      relatorios: id
    }),
    data: {
      dataPagamento: dataPagamento
    }
  })
}

function formatDate(date) {
  return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY');
}

module.exports = {
  init: AlterarDataPagamento,
  url: route('app.admin.pagamentos.extrato')
}

